import {createFileRoute} from '@tanstack/react-router';

import {EditJobPage} from '@/modules/jobs/pages/EditJobPage';

const RouteComponent = () => {
  const {jobId} = Route.useParams();
  return <EditJobPage jobId={jobId} />;
};

export const Route = createFileRoute('/_authenticated/jobs/$jobId_/edit')({
  component: RouteComponent,
});
